import * as i0 from '@angular/core';
import { ElementRef, Component, ChangeDetectionStrategy, Input, ViewChild } from '@angular/core';
import { NgDocTooltipDirective } from '@ng-doc/ui-kit';
const _c0 = ["contentProjection"];
const _c1 = ["*"];
let NgDocTooltipWrapperComponent = /*#__PURE__*/(() => {
  class NgDocTooltipWrapperComponent {
    constructor(changeDetectorRef) {
      this.changeDetectorRef = changeDetectorRef;
      this.tooltipElement = null;
    }
    ngAfterViewInit() {
      if (this.contentProjection) {
        const element = this.contentProjection.nativeElement.querySelector('[ngDocTooltip]');
        this.tooltipElement = element instanceof HTMLElement ? element : null;
        this.changeDetectorRef.detectChanges();
      }
    }
    static {
      this.ɵfac = function NgDocTooltipWrapperComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocTooltipWrapperComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocTooltipWrapperComponent,
        selectors: [["ng-doc-tooltip-wrapper"]],
        viewQuery: function NgDocTooltipWrapperComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentProjection = _t.first);
          }
        },
        inputs: {
          content: "content"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c1,
        decls: 3,
        vars: 3,
        consts: [["contentProjection", ""], [1, "content-projection", 3, "ngDocTooltip", "displayOrigin", "pointerOrigin"]],
        template: function NgDocTooltipWrapperComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_1_0;
            let tmp_2_0;
            let tmp_3_0;
            const contentProjection_r1 = i0.ɵɵreference(1);
            i0.ɵɵproperty("ngDocTooltip", (tmp_1_0 = ctx.content) !== null && tmp_1_0 !== undefined ? tmp_1_0 : "")("displayOrigin", (tmp_2_0 = ctx.tooltipElement) !== null && tmp_2_0 !== undefined ? tmp_2_0 : contentProjection_r1)("pointerOrigin", (tmp_3_0 = ctx.tooltipElement) !== null && tmp_3_0 !== undefined ? tmp_3_0 : contentProjection_r1);
          }
        },
        dependencies: [NgDocTooltipDirective],
        styles: [".content-projection[_ngcontent-%COMP%]{display:unset}"],
        changeDetection: 0
      });
    }
  }
  return NgDocTooltipWrapperComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const tooltipProcessor = {
  component: NgDocTooltipWrapperComponent,
  selector: '[ngDocTooltip]',
  extractOptions: element => ({
    inputs: {
      content: element.getAttribute('ngDocTooltip') ?? ''
    },
    content: [[element.cloneNode(true)]]
  })
};

/**
 * Generated bundle index. Do not edit.
 */

export { tooltipProcessor };
